module.exports = __webpack_public_path__ + "img/img1.9d8241d8.png";